import { makeStyles } from '@material-ui/styles';

export const useStyle = makeStyles(function() {
  return {
    heroRoot: {
      position: 'relative',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #007a60 0%, #009677 35%, #50b848 70%, #8dc63f 100%)',
      display: 'flex',
      flexDirection: 'column',
    },
    heroContent: {
      flex: '1',
      display: 'flex',
      alignItems: 'center',
      padding: '40px 0',
    },
    brandSide: {
      padding: '40px 60px',
      color: '#FFFFFF',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    logoTop: {
      position: 'absolute',
      top: '0',
      left: '16px',
      height: '80px',
      width: 'auto',
      display: 'block',
    },
    tagline: {
      fontFamily: 'Lato',
      fontWeight: '700',
      fontSize: '40px',
      lineHeight: '52px',
      color: '#FFFFFF',
      marginBottom: '20px',
      marginTop: '0',
    },
    subTagline: {
      fontFamily: 'Open Sans',
      fontWeight: '400',
      fontSize: '16px',
      lineHeight: '26px',
      color: 'rgba(255,255,255,0.85)',
      maxWidth: '420px',
      marginTop: '0',
    },
    divider: {
      width: '60px',
      height: '4px',
      background: 'rgba(255,255,255,0.4)',
      borderRadius: '2px',
      margin: '24px 0',
      border: 'none',
    },
    formSide: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 40px',
    },
  };
});
